import React from 'react';

import { RawProjectData } from '@interfaces/projects';

import TalentAccordian from './TalentAccordian';

interface MainContentProps {
  className?: string;
  notes: string;
  profiles: RawProjectData[];
  projectSlug: string;
}

const MainContent = ({ className, notes, profiles, projectSlug }: MainContentProps) => {
  return (
    <>
      <div className={className}>
        {profiles.map((profile) => (
          <TalentAccordian key={profile.name} profile={profile} projectSlug={projectSlug} />
        ))}
      </div>
      <cite className="mb-0 mt-24 block font-suisse-screen text-byline-sm not-italic text-primary-black">
        {notes}
      </cite>
    </>
  );
};

export default MainContent;
